import React from 'react';
import * as format from '@format';

import s from './MonthlyIncomeRatio.module.scss';

type MonthlyIncomeRatioType = {
  monthlyCombinedIncome?: number | null;
  monthlyExpenses?: number | null;
};

type MedianIncomeProps = {
  value: MonthlyIncomeRatioType | null;
};

const DEFAULT_NULL_CHAR = '-';

const MonthlyIncomeRatio: React.FC<MedianIncomeProps> = ({
  value,
}) => {
  const netIncome = value?.monthlyCombinedIncome && value?.monthlyExpenses
    ? value.monthlyCombinedIncome - value.monthlyExpenses
    : null;

  const getNetIncomeClass = (): string => {
    if (netIncome === null) return s.netIncomeNeutral;
    if (netIncome > 0) return s.netIncomePositive;
    if (netIncome < 0) return s.netIncomeNegative;
    return s.netIncomeNeutral;
  };
  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className={s.halfWidth}>
          <div className={s.column}>
            <span className='body-sm'>Monthly Net Income</span>
            <span className={`body-md-bold ${getNetIncomeClass()}`}>
              {netIncome !== null
                ? format.price.withCurrency(netIncome, 'USD')
                : DEFAULT_NULL_CHAR}
            </span>
          </div>
        </div>
        <div className={s.quarterWidth}>
          <span className='body-sm'>Monthly Combined Income</span>
          <span className='body-md-bold'>
            {value?.monthlyCombinedIncome ? `$${value?.monthlyCombinedIncome}` : DEFAULT_NULL_CHAR}
          </span>
        </div>
        <div className={s.fifthWidth}>
          <span className='body-sm'>Monthly Expenses</span>
          <span className='body-md-bold'>
            {value?.monthlyExpenses ? `$${value?.monthlyExpenses}` : DEFAULT_NULL_CHAR}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MonthlyIncomeRatio;
